import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Marsh,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: -1,
  water_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const MarshEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Marsh),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type MarshEntity = InferOutput<typeof MarshEntitySchema>

/**
 * Wetland area with waterlogged soil and grassy vegetation, often found at the edges of water bodies.
 */
export const MarshEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Marsh,
  dname: 'Marsh',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createMarshEntity(id: number, x: number, y: number): MarshEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
